module.exports = __webpack_public_path__ + "img/pause.a3a08e6b.svg";